import { UseMutationOptions } from '@tanstack/react-query';
import { NestedSegmentDefinitionInput } from 'domains/segments/types';
import { CuredApiPaths } from 'models/enums';
import { RowDisplayCondition } from 'hooks/queries/useDisplayConditions';
import useMutation from '../useMutation';
import MutationKeys from './keys';

export type DisplayConditionPostBody = {
    label: string;
    condition: NestedSegmentDefinitionInput;
    description: string;
    category: string;
};

/**
 * Creates a display condition.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useCreateDisplayCondition = (
    mutateOptions?: UseMutationOptions<RowDisplayCondition, Error, DisplayConditionPostBody>
) =>
    useMutation<DisplayConditionPostBody, RowDisplayCondition>(
        MutationKeys.CREATE_DISPLAY_CONDITION,
        CuredApiPaths.ROW_DISPLAY_CONDITIONS,
        mutateOptions
    );

export default useCreateDisplayCondition;
